// Circular ROI Shield Meter — SVG
export const ShieldMeter = ({ score = 0, grade = 'F', size = 220, testId }) => {
  const r = (size / 2) - 18;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * r;
  const safe = Math.max(0, Math.min(100, score));
  const offset = circumference - (safe / 100) * circumference;
  const color = safe >= 80 ? '#D4AF37' : safe >= 60 ? '#C8A95A' : safe >= 40 ? '#A78441' : '#5A4B22';

  return (
    <div data-testid={testId} className="relative inline-block">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={cx} cy={cy} r={r} stroke="#1a1a1a" strokeWidth="2" fill="none" />
        <circle
          cx={cx} cy={cy} r={r}
          stroke={color}
          strokeWidth="2"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 1.2s cubic-bezier(0.22, 1, 0.36, 1)' }}
        />
        {/* Tick marks */}
        {Array.from({ length: 60 }).map((_, i) => {
          const angle = (i / 60) * 2 * Math.PI;
          const inner = r - 8;
          const outer = r - 3;
          const x1 = cx + Math.cos(angle) * inner;
          const y1 = cy + Math.sin(angle) * inner;
          const x2 = cx + Math.cos(angle) * outer;
          const y2 = cy + Math.sin(angle) * outer;
          const isActive = (i / 60) * 100 <= safe;
          return (
            <line key={i} x1={x1} y1={y1} x2={x2} y2={y2}
              stroke={isActive ? color : '#1f1f1f'} strokeWidth="1" />
          );
        })}
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="text-[9px] tracking-[0.4em] uppercase text-[#A3A3A3] mb-1">Shield</div>
        <div className="font-display text-6xl leading-none" style={{ color }}>{safe}</div>
        <div className="text-[9px] tracking-[0.4em] uppercase mt-2" style={{ color }}>Grade {grade}</div>
      </div>
    </div>
  );
};

export const StageBar = ({ stage, pctSpent = 0 }) => (
  <div className="border-b border-[#D4AF37]/15 pb-4">
    <div className="flex items-center justify-between mb-2">
      <span className="text-sm tracking-wide font-light text-[#F5F5F5]">{stage.name}</span>
      <span className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]">
        {stage.pct_of_budget}% · {stage.duration_weeks}w
      </span>
    </div>
    <div className="h-[2px] bg-[#1a1a1a] relative overflow-hidden">
      <div
        className="absolute top-0 left-0 h-full bg-[#D4AF37]"
        style={{ width: `${Math.min(100, Math.max(0, pctSpent))}%`, transition: 'width 0.9s ease' }}
      />
    </div>
  </div>
);
